import '../Styles/NotFound.css';
function NotFound() {
return(
    <div className="notfound">
        <div className="notfoundcard">
            <div className="code">CODE 404</div>
            <div className="smalltext">page not found</div>
        </div>
    </div>
);
}

export default NotFound;